import { App } from '@omaze/app';
import { GRID_CELL_SIZE, OzGrid, OzGridCell, OzGridRow, OzPage } from '@omaze/omaze-ui';
import React, { ReactElement } from 'react';

import { Portal } from '../shared/Portal/Portal.component';
import { Underline } from '../shared/underline/Underline';

import { AccreditedBusiness } from './accredited-business/AccreditedBusiness';
import { Divider, DIVIDER_THICKNESS } from './divider/Divider';
import { getEmailCaptureModule } from './email-capture/email-capture-module/email-capture.module';
import { EmailCapture } from './email-capture/EmailCapture';
import { FooterTestIds } from './FooterTestIds';
import { LinkSections } from './link-sections/LinkSections';
import { OmazeLogo } from './omaze-logo/OmazeLogo';
import { SocialIcons } from './social-icons/SocialIcons';

export function Footer (): ReactElement {
    return (
        <Portal el="js-footer__root">
            <App featureFlags={{}} modules={[getEmailCaptureModule()]}>
                <div className="bg-rebrand-navy-500 font-gellix py-4 lg:pt-7 lg:pb-10 text-white"
                    data-testid={FooterTestIds.CONTAINER}
                >
                    <OzPage>
                        <OzGrid>
                            <OzGridRow>
                                <OzGridCell size={GRID_CELL_SIZE.COLUMN_4} mdSize={GRID_CELL_SIZE.COLUMN_8}>
                                    <EmailCapture/>
                                    <Divider thickness={DIVIDER_THICKNESS.THIN} className="bg-white mt-4 mb-4"/>
                                    <div className="text-xl font-bold mb-1">JOIN THE COMMUNITY</div>
                                    <SocialIcons/>
                                    <Divider thickness={DIVIDER_THICKNESS.THIN} className={'bg-white mt-4 mb-4'}/>
                                    <div className="text-med font-bold mb-1 lg:mb-2">Need help?</div>
                                    <div className="text-med font-normal">
                                        Email our support team at {' '}
                                        <Underline className="align-bottom" animationStyle="underlineRemains"
                                            underlineRemainsColor="white"
                                        >
                                            <a
                                                className="text-med font-regular"
                                                href="mailto: weloveyou@omaze.com"
                                            >
                                                weloveyou@omaze.com
                                            </a>
                                        </Underline>
                                    </div>
                                    <Divider thickness={DIVIDER_THICKNESS.THIN}
                                        className="bg-white mt-4 mb-4 lg:hidden"
                                    />
                                </OzGridCell>
                                <OzGridCell
                                    size={GRID_CELL_SIZE.COLUMN_4}
                                    mdSize={GRID_CELL_SIZE.COLUMN_8}
                                    lgSize={GRID_CELL_SIZE.COLUMN_6}
                                    lgOffset={GRID_CELL_SIZE.COLUMN_2}
                                >
                                    <LinkSections/>
                                    <Divider thickness={DIVIDER_THICKNESS.THIN}
                                        className="bg-white mt-4 mb-4 lg:hidden"
                                    />
                                    <OzGrid className="lg:mt-10">
                                        <OzGridRow>
                                            <OzGridCell size={GRID_CELL_SIZE.COLUMN_4} lgSize={GRID_CELL_SIZE.COLUMN_4}>
                                                <OmazeLogo/>
                                                <div className="text-xs mb-3 lg:mb-0 mt-3 font-gellix">
                                                    Copyright &#169; 2022, Omaze, Inc. All rights reserved.
                                                </div>
                                            </OzGridCell>
                                            <OzGridCell className="mb-32" size={GRID_CELL_SIZE.COLUMN_4} lgSize={GRID_CELL_SIZE.COLUMN_2}>
                                                <AccreditedBusiness/>
                                            </OzGridCell>
                                        </OzGridRow>
                                    </OzGrid>
                                </OzGridCell>
                            </OzGridRow>
                        </OzGrid>
                    </OzPage>
                </div>
            </App>
        </Portal>
    );
}
